import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useParams, useLocation } from 'react-router-dom';
import { checkUser } from 'src/actions/userActions';
import { Spin } from 'antd';
import { connect } from 'react-redux';
import { checkIfObjectEmpty } from 'src/utils/helper';
import store from 'src/redux/store/reduxStoreIndex';
import { getModelListRedux } from 'src/redux/actions/modelListActions';
import { getSettingsRedux } from 'src/redux/actions/settingsActions';
import { getActiveModelRedux } from 'src/redux/actions/activeModelActions';

// this component checks the authentication status of a user and only renders the requested route if the user is authenticated,
// otherwise it redirects to login page
const ProtectedRoute = (props) => {
	const { activeUser, activeModel, modelList, settings } = props;
	const params = useParams();
	const { pathname } = useLocation();
	const { modelSlug } = params;
	const { model } = activeModel;

	const [checkedAuth, setCheckedAuth] = useState(false);

	// TODO: It doesnt make sense to do this in the client. It should fully work via the API
	const checkIfUserHasAccess = (user) => {
		if (user?.adminAccess) return true;
		if (user && user.modelAccess && user.modelAccess.includes(modelSlug)) return true;
		const userAcessIds = user.modelAccess.map((slug) => modelList.items.find((m) => m.slug === slug)?._id);
		if (userAcessIds.includes(params.modelId)) return true;
		return false;
	};

	const checkIfModelPublic = (slug) => {
		const requestedModel = modelList.items.find((m) => m.slug === slug);
		return requestedModel === undefined
			? false
			: requestedModel.isActive && ['public', 'link'].includes(requestedModel.publicModel);
	};

	// call the authenticate method, that throws an error if the user is not authenticated
	useEffect(() => {
		let shouldUpdate = true;
		if (checkIfObjectEmpty(activeUser.user) && !activeUser.isFetching) {
			checkUser().then(() => {
				if (shouldUpdate) setCheckedAuth(true);
			});
		} else {
			setCheckedAuth(true);
		}

		return () => {
			shouldUpdate = false;
		};
	}, [activeUser]);

	useEffect(() => {
		if (!settings.isFetching.menuColor && settings.menuColor.init) {
			store.dispatch(getSettingsRedux('menuColor'));
		}
	}, [settings]);

	useEffect(() => {
		if ((modelList.items.length === 0 || !modelList?.items[0]?._id) && !modelList.isFetching) {
			store.dispatch(getModelListRedux());
		}

		if (activeModel.isFetching) return;

		if (model._id === '' && params.modelId) {
			store.dispatch(getActiveModelRedux(params.modelId));
			return;
		}
		if (model._id === '' && params.modelSlug) {
			store.dispatch(getActiveModelRedux(params.modelSlug, true));
			return;
		}
		if (
			model._id === '' &&
			activeUser.user.modelAccess &&
			activeUser.user.modelAccess.length !== 0 &&
			modelList.items.length > 1
		) {
			const firstModelId = modelList.items.find((item) => item.slug === activeUser.user.modelAccess[0])?._id;
			store.dispatch(getActiveModelRedux(firstModelId));
		}
	}, [activeUser.user]);

	if (activeUser.isFetching || !checkedAuth || modelList.isFetching) {
		return (
			<div
				style={{
					height: '100vh',
					width: '100vw',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<Spin spinning />
			</div>
		);
	}

	// if a user is authenticated, the specified component is rendered,
	// if user tries to access a public model, the specified component is also rendered
	// otherwise the user is redirected to the login page

	if (!checkIfObjectEmpty(activeUser.user)) {
		// authenticated
		if (
			(modelList.length !== 0 && checkIfUserHasAccess(activeUser.user)) ||
			(pathname.includes('/adminView/') && activeUser.user.adminAccess) ||
			pathname === '/userProfile' ||
			checkIfModelPublic(modelSlug)
		) {
			return <Outlet />;
		} else {
			return <Navigate to='/' />;
		}
	} else if (checkIfObjectEmpty(activeUser.user)) {
		// not authenticated

		if (checkIfModelPublic(modelSlug)) {
			return <Outlet />;
		} else {
			return <Navigate to='/' />;
		}
	}
};

const mapStateToProps = (state) => ({
	activeModel: state.activeModel,
	modelList: state.modelList,
	activeUser: state.activeUser,
	settings: state.settings,
});

export default connect(mapStateToProps)(ProtectedRoute);
